import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Investorshub = () =>{
  return (
    <>
    <Header/>
		<section className="section-content-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="about-us-intro">
							<p className="blue">Investors Hub</p>
							<h2 className="heading">Junna Solar Investor Relationship</h2>
                          As India's leading fully integrated solar solutions provider, Junna Solar offers investors a unique opportunity to <br />participate in the rapidly growing renewable energy market.  We are committed to transparency and open <br />communication, providing detailed insights into our performance, strategy, and vision for a sustainable future.
                        </div>                            
                    </div> 
					
                </div>
            </div> 
        </section>
		
		<div className="container"><hr /></div>
		
		
		<section className="section-content-block">

            <div className="container">
                
                <div className="row pb-100">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                        <div className="about-us-intro">
							<p className="our-experience">Annual Report</p>
							
                           Stay informed about Junna Solar's growth trajectory by accessing our annual reports.
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">BIS Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Incorporation Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Udyam Registration Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					
                </div>
				
				<div className="container"><hr /></div>
               <div className="row pb-100 pt-100">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                        <div className="about-us-intro">
							<p className="our-experience">Financial Reports</p>
							
                           Stay informed about Junna Solar's financial performance with our detailed financial reports.
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">BIS Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Incorporation Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Udyam Registration Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					
                </div>
				<div className="container"><hr /></div>
<div className="row  pt-100">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                        <div className="about-us-intro">
							<p className="our-experience">Board Meeting Updates</p>
							
                           Stay informed about the latest developments and strategic initiatives discussed by Junna’s board.
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">BIS Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Incorporation Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div> 
					<div className="col-lg-4 col-md-4 col-sm-12 text-center">                       
                        <div className="Products">
							 <img src="/images/ar1.jpg" alt="" /> 
							<h4 className="heading">Udyam Registration Certificate</h4>
                           	<a className="download1" href="">Download</a>
                        </div>                            
                    </div>
					
                </div>
				
				
				
            </div> 

        </section>

    <Footer/>    
    </>
  )
}

export default Investorshub